"use strict";

var _slicedToArray = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hdkey_1 = __importDefault(require("hdkey"));

var bip39_1 = require("bip39");

var query_1 = require("@eth-sdk/query");

var utils_1 = require("@eth-sdk/utils");

var ethereumjs_tx_1 = require("ethereumjs-tx");

var ethereumjs_common_1 = __importDefault(require("ethereumjs-common"));

var Key = /*#__PURE__*/function (_query_1$WithQuery) {
  _inherits(Key, _query_1$WithQuery);

  var _super = _createSuper(Key);

  function Key() {
    var _this;

    var privateKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Key);

    _this = _super.call(this, query);
    _this.privateKey = privateKey;
    _this.nonce = null;
    _this.type = null;

    if (privateKey) {
      if (!utils_1.verifyPrivateKey(privateKey)) {
        throw new Error('invalid private key');
      }

      _this.currentAddress = utils_1.publicKeyToAddress(utils_1.privateToPublicKey(privateKey));
      _this.type = Key.Types.Local;
    } else if (query) {
      _this.type = Key.Types.Network;
    }

    return _this;
  }

  _createClass(Key, [{
    key: "fetchAddress",
    value: function fetchAddress() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var addresses, address;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.type === Key.Types.Network)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.query.eth.accounts;

              case 3:
                addresses = _context.sent;
                address = utils_1.toChecksumAddress(addresses[index]);
                this.currentAddress = address;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "signPersonalMessage",
    value: function signPersonalMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = null;
                _context2.t0 = this.type;
                _context2.next = _context2.t0 === Key.Types.Local ? 4 : _context2.t0 === Key.Types.Network ? 6 : 10;
                break;

              case 4:
                result = utils_1.signPersonalMessage(message, this.privateKey);
                return _context2.abrupt("break", 11);

              case 6:
                _context2.next = 8;
                return this.query.eth.sign(this.address, utils_1.toHex(message));

              case 8:
                result = _context2.sent;
                return _context2.abrupt("break", 11);

              case 10:
                throw new Error('invalid private key');

              case 11:
                return _context2.abrupt("return", result);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "signTypedMessage",
    value: function signTypedMessage(message) {
      return utils_1.signTypedMessage(message, this.privateKey);
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result, to, value, data, nonce, gasPrice, gas, chainId, networkId, common, transaction;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                result = null;

                if (!(this.type === Key.Types.Local)) {
                  _context3.next = 31;
                  break;
                }

                to = options.to, value = options.value, data = options.data;
                nonce = options.nonce, gasPrice = options.gasPrice, gas = options.gas;

                if (nonce) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 7;
                return this.query.eth.getTransactionCount(this.address, 'pending');

              case 7:
                nonce = _context3.sent;

                if (this.nonce !== null && this.nonce >= nonce) {
                  nonce = this.nonce + 1;
                }

                this.nonce = nonce;
                _context3.next = 13;
                break;

              case 12:
                this.nonce = utils_1.toNumber(nonce);

              case 13:
                if (gasPrice) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 16;
                return this.query.eth.gasPrice;

              case 16:
                gasPrice = _context3.sent;

              case 17:
                if (!gas) {
                  gas = 21000;
                }

                _context3.next = 20;
                return this.query.eth.chainId;

              case 20:
                chainId = _context3.sent;
                _context3.next = 23;
                return this.query.net.version;

              case 23:
                networkId = _context3.sent;
                common = null;

                try {
                  common = new ethereumjs_common_1.default(chainId, 'istanbul');
                } catch (err) {
                  common = ethereumjs_common_1.default.forCustomChain(1, {
                    chainId: chainId,
                    networkId: networkId,
                    comment: 'Custom chain'
                  }, 'istanbul');
                }

                transaction = new ethereumjs_tx_1.Transaction({
                  to: to,
                  nonce: utils_1.toHex(nonce, '0x00', true),
                  gasLimit: utils_1.toHex(gas, '0x00', true),
                  gasPrice: utils_1.toHex(gasPrice, '0x00', true),
                  value: utils_1.toHex(value, '0x00', true),
                  data: utils_1.toHex(data, '0x')
                }, {
                  common: common
                });
                transaction.sign(utils_1.toBuffer(this.privateKey));
                result = utils_1.toHex(transaction.serialize());
                _context3.next = 32;
                break;

              case 31:
                throw new Error('invalid key');

              case 32:
                return _context3.abrupt("return", result);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "extendProvider",
    value: function extendProvider(method, params) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var result, address, data, _params, options, _params2, _options, from, to, _data, value, nonce, gas, gasPrice, raw;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                result = null;

                if (!(this.type === Key.Types.Local)) {
                  _context4.next = 27;
                  break;
                }

                _context4.t0 = method;
                _context4.next = _context4.t0 === query_1.queryModules.Eth.Methods.Accounts ? 5 : _context4.t0 === query_1.queryModules.Eth.Methods.Sign ? 7 : _context4.t0 === query_1.queryModules.Eth.Methods.SendTransaction ? 16 : 27;
                break;

              case 5:
                result = [this.address];
                return _context4.abrupt("break", 27);

              case 7:
                _params = _slicedToArray(params, 2);
                address = _params[0];
                data = _params[1];
                address = utils_1.toChecksumAddress(address);

                if (!(address === this.address)) {
                  _context4.next = 15;
                  break;
                }

                _context4.next = 14;
                return this.signPersonalMessage(data);

              case 14:
                result = _context4.sent;

              case 15:
                return _context4.abrupt("break", 27);

              case 16:
                _params2 = _slicedToArray(params, 1);
                options = _params2[0];
                _options = options, from = _options.from, to = _options.to, _data = _options.data, value = _options.value, nonce = _options.nonce, gas = _options.gas, gasPrice = _options.gasPrice;

                if (!(from === this.address)) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 22;
                return this.signTransaction({
                  to: to,
                  nonce: nonce,
                  data: _data,
                  value: value,
                  gas: gas,
                  gasPrice: gasPrice
                });

              case 22:
                raw = _context4.sent;
                _context4.next = 25;
                return this.query.eth.sendRawTransaction(raw);

              case 25:
                result = _context4.sent;

              case 26:
                return _context4.abrupt("break", 27);

              case 27:
                return _context4.abrupt("return", result);

              case 28:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "address",
    get: function get() {
      return this.currentAddress;
    }
  }], [{
    key: "createRandom",
    value: function createRandom() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new Key(utils_1.randomPrivateKey(), query);
    }
  }, {
    key: "createLocalKeyFromMnemonic",
    value: function createLocalKeyFromMnemonic(mnemonic) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      options = Object.assign({
        hdPath: this.DEFAULT_HD_PATH,
        index: 0
      }, options);
      var _options2 = options,
          hdPath = _options2.hdPath,
          password = _options2.password,
          index = _options2.index;

      var _this$createLocalKeys = this.createLocalKeysFromMnemonic(mnemonic, query, {
        hdPath: hdPath,
        password: password,
        fromIndex: index,
        toIndex: index
      }),
          _this$createLocalKeys2 = _slicedToArray(_this$createLocalKeys, 1),
          result = _this$createLocalKeys2[0];

      return result || null;
    }
  }, {
    key: "createLocalKeysFromMnemonic",
    value: function createLocalKeysFromMnemonic(mnemonic) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var result = [];
      options = Object.assign({
        hdPath: this.DEFAULT_HD_PATH,
        fromIndex: 0,
        toIndex: 9
      }, options);
      var _options3 = options,
          hdPath = _options3.hdPath,
          password = _options3.password,
          fromIndex = _options3.fromIndex,
          toIndex = _options3.toIndex;
      var seed = bip39_1.mnemonicToSeedSync(mnemonic, password);
      var rootHdNode = hdkey_1.default.fromMasterSeed(seed);

      for (var index = fromIndex; index <= toIndex; index += 1) {
        var hdNode = rootHdNode.derive("".concat(hdPath, "/").concat(index));
        var privateKey = utils_1.toHex(hdNode.privateKey);
        result.push(new Key(privateKey, query));
      }

      return result;
    }
  }]);

  return Key;
}(query_1.WithQuery);

exports.Key = Key;
Key.DEFAULT_HD_PATH = 'm/44\'/60\'/0\'/0';

(function (Key) {
  var Types;

  (function (Types) {
    Types["Network"] = "Network";
    Types["Local"] = "Local";
  })(Types = Key.Types || (Key.Types = {}));
})(Key = exports.Key || (exports.Key = {}));